import useScreenWidth from '../../../../../../hooks/useScreenWidth';

const SummarySection = ({ data }) => {
    const screenWidth = useScreenWidth();
    return (
        <div className="summary-section">
            {screenWidth < 767 ? (
                <div className="d-flex flex-column gap-3">
                    {data?.map((res) => (
                        <div
                            key={'resumen-mobile-' + res.id}
                            className="mobile-card"
                        >
                            <p className="text-uppercase text-center">
                                {res.nombre}
                            </p>
                            <div className="mobile-card__container">
                                <div>
                                    <span className="mobile-card__container--title">
                                        Presup. Día:
                                    </span>
                                    <span>
                                        {res?.presupuestos_dia}
                                    </span>
                                </div>
                                <div>
                                    <span className="mobile-card__container--title">
                                        Presup. Mes:
                                    </span>
                                    <span>
                                        {res?.presupuestos_mes}
                                    </span>
                                </div>
                                <div>
                                    <span className="mobile-card__container--title">
                                        Ventas:
                                    </span>
                                    <span>
                                        {res?.ventas}
                                    </span>
                                </div>
                                <div>
                                    <span className="mobile-card__container--title">
                                        Fact. Día:
                                    </span>
                                    <span>
                                        {res?.facturacion_dia}
                                    </span>
                                </div>
                                <div>
                                    <span className="mobile-card__container--title">
                                        Fact. Mes:
                                    </span>
                                    <span className="text-right">
                                        {res?.facturacion_mes}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="summary-section__container">
                    <table>
                        <thead>
                            <tr>
                                <th className="text-center text-uppercase">
                                    recambista
                                </th>
                                <th className="text-center text-uppercase">
                                    presupuestos diarios
                                </th>
                                <th className="text-center text-uppercase">
                                    presupuestos mensuales
                                </th>
                                <th className="text-center text-uppercase">
                                    ventas generadas
                                </th>
                                <th className="text-center text-uppercase">
                                    facturación diaria
                                </th>
                                <th className="text-center text-uppercase">
                                    facturación mensual
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((res) => {
                                return (
                                    <tr key={'resumen-' + res.id}>
                                        <td className="text-center text-uppercase">
                                            {res.nombre}
                                        </td>
                                        <td className="text-center">
                                            {res?.presupuestos_dia}
                                        </td>
                                        <td className="text-center">
                                            {res?.presupuestos_mes}
                                        </td>
                                        <td className="text-center">
                                            {res?.ventas}
                                        </td>
                                        <td className="text-center">
                                            {res?.facturacion_dia}€
                                        </td>
                                        <td className="text-center">
                                            {res?.facturacion_mes}€
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default SummarySection;
